// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==================== ImageSettingsPopup.css ====================
   All classes prefixed isp- to avoid global collisions.
   Shared st-switch/st-slider from SettingsGridLayout.css
   ============================================================== */

/* ── Backdrop ──────────────────────────────────────────────────────────── */
.isp-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.72);
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    z-index: 2000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    box-sizing: border-box;
    animation: isp-backdropIn 0.2s ease;
  }
  
  .isp-backdrop--out {
    animation: isp-backdropOut 0.22s ease forwards;
  }
  
  @keyframes isp-backdropIn  { from { opacity: 0; } to { opacity: 1; } }
  @keyframes isp-backdropOut { from { opacity: 1; } to { opacity: 0; } }
  
  /* ── Modal shell ───────────────────────────────────────────────────────── */
  .isp-modal {
    background: rgb(18, 18, 22);
    border: 1px solid rgba(255, 255, 255, 0.10);
    border-radius: 18px;
    width: 100%;
    max-width: 560px;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-shadow: 0 24px 64px rgba(0, 0, 0, 0.70);
    animation: isp-modalIn 0.22s cubic-bezier(0.34, 1.20, 0.64, 1);
  }
  
  .isp-modal--out {
    animation: isp-modalOut 0.18s ease forwards;
  }
  
  @keyframes isp-modalIn {
    from { opacity: 0; transform: scale(0.92) translateY(16px); }
    to   { opacity: 1; transform: scale(1)    translateY(0);    }
  }
  
  @keyframes isp-modalOut {
    from { opacity: 1; transform: scale(1);    }
    to   { opacity: 0; transform: scale(0.94); }
  }
  
  /* ── Header ────────────────────────────────────────────────────────────── */
  .isp-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 22px 24px 18px 24px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.07);
    flex-shrink: 0;
  }
  
  .isp-header-left {
    display: flex;
    align-items: center;
    gap: 14px;
  }
  
  .isp-header-icon {
    font-size: 1.8rem;
    flex-shrink: 0;
  }
  
  .isp-title {
    font-size: 1.1rem;
    font-weight: 700;
    color: #ffffff;
    margin: 0 0 3px 0;
    padding: 0;
  }
  
  .isp-subtitle {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.38);
    margin: 0;
    padding: 0;
  }
  
  .isp-close-btn {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.07);
    border: 1px solid rgba(255, 255, 255, 0.10);
    color: rgba(255, 255, 255, 0.60);
    font-size: 20px;
    line-height: 1;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s ease, color 0.15s ease;
    flex-shrink: 0;
  }
  
  .isp-close-btn:hover {
    background: rgba(244, 67, 54, 0.18);
    color: #f44336;
  }
  
  /* ── Live preview strip ────────────────────────────────────────────────── */
  .isp-preview-strip {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 14px 24px;
    background: rgba(255, 255, 255, 0.025);
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    flex-shrink: 0;
  }
  
  .isp-preview-avatar {
    position: relative;
    width: 52px;
    height: 52px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.06);
    border: 2px solid rgba(255, 255, 255, 0.12);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    overflow: hidden;
  }
  
  .isp-preview-emoji { font-size: 1.8rem; }
  
  .isp-preview-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.55);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.4rem;
    border-radius: 50%;
  }
  
  .isp-preview-details { flex: 1 1; min-width: 0; }
  
  .isp-preview-row {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-bottom: 6px;
  }
  
  .isp-preview-chip {
    font-size: 11px;
    font-weight: 600;
    padding: 4px 10px;
    border-radius: 20px;
    border: 1px solid transparent;
    white-space: nowrap;
  }
  
  .isp-preview-chip--neutral {
    background: rgba(255, 255, 255, 0.06);
    border-color: rgba(255, 255, 255, 0.10);
    color: rgba(255, 255, 255, 0.55);
  }
  
  .isp-preview-chip--virtual {
    background: rgba(156, 39, 176, 0.14);
    border-color: rgba(156, 39, 176, 0.30);
    color: #ce93d8;
  }
  
  .isp-preview-hint {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.28);
    margin: 0;
    padding: 0;
  }
  
  /* ── Tab bar ───────────────────────────────────────────────────────────── */
  .isp-tabs {
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid rgba(255, 255, 255, 0.07);
    flex-shrink: 0;
    overflow-x: auto;
    scrollbar-width: none;
  }
  
  .isp-tabs::-webkit-scrollbar { display: none; }
  
  .isp-tab {
    flex: 1 1;
    padding: 13px 16px;
    background: transparent;
    border: none;
    border-bottom: 3px solid transparent;
    color: rgba(255, 255, 255, 0.42);
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
    transition: color 0.18s ease, border-bottom-color 0.18s ease;
    letter-spacing: 0.01em;
  }
  
  .isp-tab:hover { color: rgba(255, 255, 255, 0.75); }
  
  .isp-tab--active {
    color: #ffffff !important;
    border-bottom-color: white;
  }
  
  /* ── Scrollable body ───────────────────────────────────────────────────── */
  .isp-body {
    flex: 1 1;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 255, 255, 0.12) transparent;
  }
  
  .isp-body::-webkit-scrollbar       { width: 5px; }
  .isp-body::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.12);
    border-radius: 10px;
  }
  
  /* ── Tab content wrapper ───────────────────────────────────────────────── */
  .isp-tab-content {
    padding: 22px 24px;
    animation: isp-tabFade 0.18s ease;
  }
  
  @keyframes isp-tabFade {
    from { opacity: 0; transform: translateY(5px); }
    to   { opacity: 1; transform: translateY(0);   }
  }
  
  .isp-section-desc {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.45);
    margin: 0 0 18px 0;
    line-height: 1.65;
  }
  
  /* ── TAB 1: Visibility option cards ────────────────────────────────────── */
  .isp-vis-options {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  
  .isp-vis-card {
    width: 100%;
    padding: 16px 18px;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(255, 255, 255, 0.02);
    cursor: pointer;
    text-align: left;
    transition: border-color 0.18s ease, background 0.18s ease;
  }
  
  .isp-vis-card-top {
    display: flex;
    align-items: center;
    gap: 14px;
  }
  
  .isp-vis-icon {
    font-size: 1.5rem;
    flex-shrink: 0;
    width: 32px;
    text-align: center;
  }
  
  .isp-vis-info {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 3px;
    min-width: 0;
  }
  
  .isp-vis-label {
    font-size: 14px;
    font-weight: 700;
    color: rgba(255, 255, 255, 0.80);
    transition: color 0.18s ease;
  }
  
  .isp-vis-desc {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.38);
    line-height: 1.55;
  }
  
  .isp-vis-radio {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 2px solid rgba(255, 255, 255, 0.22);
    flex-shrink: 0;
    transition: border-color 0.18s ease, background 0.18s ease;
  }
  
  /* ── TAB 2: Virtual avatar grid ────────────────────────────────────────── */
  .isp-clear-avatar-btn {
    background: rgba(244, 67, 54, 0.10);
    border: 1px solid rgba(244, 67, 54, 0.25);
    color: #ef9a9a;
    border-radius: 8px;
    padding: 9px 16px;
    font-size: 12.5px;
    font-weight: 600;
    cursor: pointer;
    margin-bottom: 16px;
    transition: background 0.15s ease;
  }
  
  .isp-clear-avatar-btn:hover {
    background: rgba(244, 67, 54, 0.18);
  }
  
  .isp-avatar-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
  }
  
  .isp-avatar-card {
    position: relative;
    aspect-ratio: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 5px;
    background: rgba(255, 255, 255, 0.04);
    border: 2px solid rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    cursor: pointer;
    transition: border-color 0.18s ease, background 0.18s ease, transform 0.15s ease;
    padding: 10px 6px;
    box-sizing: border-box;
  }
  
  .isp-avatar-card:hover {
    border-color: rgba(76, 175, 80, 0.40);
    background: rgba(76, 175, 80, 0.06);
    transform: translateY(-2px);
  }
  
  .isp-avatar-card--selected {
    border-color: #4caf50 !important;
    background: rgba(76, 175, 80, 0.13) !important;
  }
  
  .isp-avatar-emoji { font-size: 2rem; }
  
  .isp-avatar-label {
    font-size: 10.5px;
    color: rgba(255, 255, 255, 0.45);
    font-weight: 600;
    text-align: center;
  }
  
  .isp-avatar-check {
    position: absolute;
    top: 5px;
    right: 7px;
    font-size: 11px;
    font-weight: 700;
    color: #81c784;
  }
  
  /* ── TAB 3: Behaviour ──────────────────────────────────────────────────── */
  .isp-behaviour-card {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 18px 20px;
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    margin-bottom: 24px;
  }
  
  .isp-behaviour-left {
    display: flex;
    align-items: center;
    gap: 14px;
    flex: 1 1;
  }
  
  .isp-behaviour-icon {
    font-size: 1.8rem;
    flex-shrink: 0;
    width: 36px;
    text-align: center;
    transition: transform 0.3s ease;
  }
  
  .isp-behaviour-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  
  .isp-behaviour-title {
    font-size: 14px;
    font-weight: 700;
    color: rgba(255, 255, 255, 0.85);
  }
  
  .isp-behaviour-desc {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.40);
    line-height: 1.55;
  }
  
  /* ── Behaviour demo ────────────────────────────────────────────────────── */
  .isp-behaviour-demo {
    background: rgba(255, 255, 255, 0.025);
    border: 1px dashed rgba(255, 255, 255, 0.10);
    border-radius: 12px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    margin-bottom: 18px;
  }
  
  .isp-behaviour-demo-label {
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: rgba(255, 255, 255, 0.28);
  }
  
  .isp-behaviour-demo-avatar {
    position: relative;
    width: 70px;
    height: 70px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.06);
    border: 2px solid rgba(255, 255, 255, 0.10);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: border-color 0.2s ease, transform 0.2s ease;
  }
  
  .isp-behaviour-demo-avatar--clickable {
    cursor: zoom-in;
    border-color: rgba(76, 175, 80, 0.35);
  }
  
  .isp-behaviour-demo-avatar--clickable:hover {
    transform: scale(1.06);
    border-color: #4caf50;
    box-shadow: 0 0 20px rgba(76, 175, 80, 0.25);
  }
  
  .isp-behaviour-demo-zoom {
    position: absolute;
    bottom: -2px;
    right: -2px;
    width: 22px;
    height: 22px;
    background: #4caf50;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    border: 2px solid rgb(18, 18, 22);
  }
  
  .isp-behaviour-demo-hint {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.35);
    margin: 0;
    text-align: center;
  }
  
  /* ── Shared: warning note ──────────────────────────────────────────────── */
  .isp-warning-note {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    background: rgba(33, 150, 243, 0.08);
    border: 1px solid rgba(33, 150, 243, 0.20);
    border-radius: 10px;
    padding: 13px 16px;
    margin-top: 14px;
  }
  
  .isp-warning-note span { font-size: 1.1rem; flex-shrink: 0; margin-top: 1px; }
  
  .isp-warning-note p {
    font-size: 12.5px;
    color: rgba(255, 255, 255, 0.55);
    margin: 0;
    padding: 0;
    line-height: 1.65;
  }
  
  /* ── Footer ────────────────────────────────────────────────────────────── */
  .isp-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    padding: 16px 24px;
    border-top: 1px solid rgba(255, 255, 255, 0.07);
    flex-shrink: 0;
  }
  
  .isp-save-btn,
  .isp-cancel-btn {
    padding: 11px 26px;
    border-radius: 9px;
    font-size: 13.5px;
    font-weight: 700;
    cursor: pointer;
    transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
    border: none;
  }
  
  .isp-save-btn {
    background: rgba(36,36,45,0.2);
    color: #fff;
    border: "1px solid white"
  }
  
  .isp-save-btn:hover {
    transform: translateY(-1px);
  }
  
  .isp-cancel-btn {
    background: rgba(255, 255, 255, 0.06);
    color: rgba(255, 255, 255, 0.60);
    border: 1px solid rgba(255, 255, 255, 0.10);
  }
  
  .isp-cancel-btn:hover {
    background: rgba(255, 255, 255, 0.10);
    color: rgba(255, 255, 255, 0.88);
  }
  
  /* ── Clickable trigger (in SelfDetail) ─────────────────────────────────── */
  .sd-img-vis-trigger {
    width: 100%;
    background: rgba(255, 255, 255, 0.025);
    border: 1px solid rgba(255, 255, 255, 0.09);
    border-radius: 12px;
    padding: 14px 16px;
    cursor: pointer;
    text-align: left;
    color: inherit;
    transition: background 0.18s ease, border-color 0.18s ease, transform 0.15s ease;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  
  /* .sd-img-vis-trigger:hover {
    background: rgba(76, 175, 80, 0.07);
    border-color: rgba(76, 175, 80, 0.30);
    transform: translateY(-1px);
  } */
  
  .sd-img-vis-trigger-top {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  
  .sd-img-vis-trigger-icon { font-size: 1.3rem; flex-shrink: 0; }
  
  .sd-img-vis-trigger-info {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 3px;
  }
  
  .sd-img-vis-trigger-label {
    font-size: 13.5px;
    font-weight: 700;
    color: rgba(255, 255, 255, 0.85);
  }
  
  .sd-img-vis-trigger-sublabel {
    font-size: 11.5px;
    color: rgba(255, 255, 255, 0.38);
  }
  
  .sd-img-vis-trigger-arrow {
    font-size: 1.4rem;
    color: rgba(255, 255, 255, 0.30);
    flex-shrink: 0;
    transition: transform 0.18s ease, color 0.18s ease;
  }
  
  .sd-img-vis-trigger:hover .sd-img-vis-trigger-arrow {
    transform: translateX(3px);
    color: rgba(76, 175, 80, 0.80);
  }
  
  .sd-img-vis-trigger-status {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 7px;
    padding-top: 2px;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
  }
  
  .sd-img-vis-chip {
    font-size: 11px;
    font-weight: 600;
    padding: 4px 10px;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.06);
    color: rgba(255, 255, 255, 0.50);
    border: 1px solid rgba(255, 255, 255, 0.09);
  }
  
  /* ── Responsive ────────────────────────────────────────────────────────── */
  @media (max-width: 600px) {
    .isp-modal          { border-radius: 14px; max-height: 95vh; }
    .isp-avatar-grid    { grid-template-columns: repeat(3, 1fr); }
    .isp-tab            { font-size: 12px; padding: 11px 10px; }
    .isp-footer         { flex-direction: column-reverse; }
    .isp-save-btn,
    .isp-cancel-btn     { width: 100%; text-align: center; }
    .isp-header         { padding: 16px 18px; }
    .isp-tab-content    { padding: 18px 16px; }
    .isp-preview-strip  { padding: 12px 16px; }
  }
  
  @media (max-width: 400px) {
    .isp-avatar-grid { grid-template-columns: repeat(3, 1fr); gap: 8px; }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Pages/common/Settings/Styles/ImageSettingsPopup.css"],"names":[],"mappings":"AAAA;;;mEAGmE;;AAEnE,6EAA6E;AAC7E;IACI,eAAe;IACf,QAAQ;IACR,+BAA+B;IAC/B,0BAA0B;IAC1B,kCAAkC;IAClC,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,mCAAmC;EACrC;;EAEA;IACE,8CAA8C;EAChD;;EAEA,6BAA6B,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;EACrE,6BAA6B,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;;EAErE,6EAA6E;EAC7E;IACE,2BAA2B;IAC3B,2CAA2C;IAC3C,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,2CAA2C;IAC3C,8DAA8D;EAChE;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;IAC5D,OAAO,UAAU,EAAE,oCAAoC,KAAK;EAC9D;;EAEA;IACE,OAAO,UAAU,EAAE,mBAAmB,KAAK;IAC3C,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC7C;;EAEA,6EAA6E;EAC7E;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,4BAA4B;IAC5B,kDAAkD;IAClD,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,gCAAgC;IAChC,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,2CAA2C;IAC3C,gCAAgC;IAChC,eAAe;IACf,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mDAAmD;IACnD,cAAc;EAChB;;EAEA;IACE,mCAAmC;IACnC,cAAc;EAChB;;EAEA,6EAA6E;EAC7E;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,sCAAsC;IACtC,kDAAkD;IAClD,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,2CAA2C;IAC3C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,gBAAgB;EAClB;;EAEA,qBAAqB,iBAAiB,EAAE;;EAExC;IACE,kBAAkB;IAClB,QAAQ;IACR,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA,uBAAuB,SAAO,EAAE,YAAY,EAAE;;EAE9C;IACE,aAAa;IACb,eAAe;IACf,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;IACrC,uCAAuC;IACvC,gCAAgC;EAClC;;EAEA;IACE,oCAAoC;IACpC,sCAAsC;IACtC,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gCAAgC;IAChC,SAAS;IACT,UAAU;EACZ;;EAEA,6EAA6E;EAC7E;IACE,aAAa;IACb,mBAAmB;IACnB,kDAAkD;IAClD,cAAc;IACd,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA,+BAA+B,aAAa,EAAE;;EAE9C;IACE,SAAO;IACP,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;IACZ,oCAAoC;IACpC,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,4DAA4D;IAC5D,sBAAsB;EACxB;;EAEA,iBAAiB,gCAAgC,EAAE;;EAEnD;IACE,yBAAyB;IACzB,0BAA0B;EAC5B;;EAEA,6EAA6E;EAC7E;IACE,SAAO;IACP,gBAAgB;IAChB,qBAAqB;IACrB,sDAAsD;EACxD;;EAEA,qCAAqC,UAAU,EAAE;EACjD;IACE,qCAAqC;IACrC,mBAAmB;EACrB;;EAEA,6EAA6E;EAC7E;IACE,kBAAkB;IAClB,iCAAiC;EACnC;;EAEA;IACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;IAC/C,OAAO,UAAU,EAAE,wBAAwB,IAAI;EACjD;;EAEA;IACE,eAAe;IACf,gCAAgC;IAChC,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA,6EAA6E;EAC7E;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,0DAA0D;EAC5D;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,4BAA4B;EAC9B;;EAEA;IACE,eAAe;IACf,gCAAgC;IAChC,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,2CAA2C;IAC3C,cAAc;IACd,0DAA0D;EAC5D;;EAEA,6EAA6E;EAC7E;IACE,mCAAmC;IACnC,yCAAyC;IACzC,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,iCAAiC;EACnC;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,qCAAqC;IACrC,2CAA2C;IAC3C,mBAAmB;IACnB,eAAe;IACf,gFAAgF;IAChF,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,qCAAqC;IACrC,mCAAmC;IACnC,2BAA2B;EAC7B;;EAEA;IACE,gCAAgC;IAChC,8CAA8C;EAChD;;EAEA,oBAAoB,eAAe,EAAE;;EAErC;IACE,iBAAiB;IACjB,gCAAgC;IAChC,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA,6EAA6E;EAC7E;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,qCAAqC;IACrC,2CAA2C;IAC3C,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,SAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,+BAA+B;EACjC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,gCAAgC;IAChC,iBAAiB;EACnB;;EAEA,6EAA6E;EAC7E;IACE,sCAAsC;IACtC,4CAA4C;IAC5C,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,2CAA2C;IAC3C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uDAAuD;EACzD;;EAEA;IACE,eAAe;IACf,qCAAqC;EACvC;;EAEA;IACE,sBAAsB;IACtB,qBAAqB;IACrB,4CAA4C;EAC9C;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,eAAe;IACf,gCAAgC;IAChC,SAAS;IACT,kBAAkB;EACpB;;EAEA,6EAA6E;EAC7E;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,oCAAoC;IACpC,0CAA0C;IAC1C,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA,yBAAyB,iBAAiB,EAAE,cAAc,EAAE,eAAe,EAAE;;EAE7E;IACE,iBAAiB;IACjB,gCAAgC;IAChC,SAAS;IACT,UAAU;IACV,iBAAiB;EACnB;;EAEA,6EAA6E;EAC7E;IACE,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,kBAAkB;IAClB,+CAA+C;IAC/C,cAAc;EAChB;;EAEA;;IAEE,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,8EAA8E;IAC9E,YAAY;EACd;;EAEA;IACE,8BAA8B;IAC9B,WAAW;IACX;EACF;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,qCAAqC;IACrC,gCAAgC;IAChC,2CAA2C;EAC7C;;EAEA;IACE,qCAAqC;IACrC,gCAAgC;EAClC;;EAEA,6EAA6E;EAC7E;IACE,WAAW;IACX,sCAAsC;IACtC,2CAA2C;IAC3C,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gFAAgF;IAChF,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;;;;KAIG;;EAEH;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA,2BAA2B,iBAAiB,EAAE,cAAc,EAAE;;EAE9D;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,iBAAiB;IACjB,gCAAgC;EAClC;;EAEA;IACE,iBAAiB;IACjB,gCAAgC;IAChC,cAAc;IACd,kDAAkD;EACpD;;EAEA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,+CAA+C;EACjD;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,qCAAqC;IACrC,gCAAgC;IAChC,2CAA2C;EAC7C;;EAEA,6EAA6E;EAC7E;IACE,sBAAsB,mBAAmB,EAAE,gBAAgB,EAAE;IAC7D,sBAAsB,qCAAqC,EAAE;IAC7D,sBAAsB,eAAe,EAAE,kBAAkB,EAAE;IAC3D,sBAAsB,8BAA8B,EAAE;IACtD;0BACsB,WAAW,EAAE,kBAAkB,EAAE;IACvD,sBAAsB,kBAAkB,EAAE;IAC1C,sBAAsB,kBAAkB,EAAE;IAC1C,sBAAsB,kBAAkB,EAAE;EAC5C;;EAEA;IACE,mBAAmB,qCAAqC,EAAE,QAAQ,EAAE;EACtE","sourcesContent":["/* ==================== ImageSettingsPopup.css ====================\n   All classes prefixed isp- to avoid global collisions.\n   Shared st-switch/st-slider from SettingsGridLayout.css\n   ============================================================== */\n\n/* ── Backdrop ──────────────────────────────────────────────────────────── */\n.isp-backdrop {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.72);\n    backdrop-filter: blur(6px);\n    -webkit-backdrop-filter: blur(6px);\n    z-index: 2000;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 20px;\n    box-sizing: border-box;\n    animation: isp-backdropIn 0.2s ease;\n  }\n  \n  .isp-backdrop--out {\n    animation: isp-backdropOut 0.22s ease forwards;\n  }\n  \n  @keyframes isp-backdropIn  { from { opacity: 0; } to { opacity: 1; } }\n  @keyframes isp-backdropOut { from { opacity: 1; } to { opacity: 0; } }\n  \n  /* ── Modal shell ───────────────────────────────────────────────────────── */\n  .isp-modal {\n    background: rgb(18, 18, 22);\n    border: 1px solid rgba(255, 255, 255, 0.10);\n    border-radius: 18px;\n    width: 100%;\n    max-width: 560px;\n    max-height: 90vh;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    box-shadow: 0 24px 64px rgba(0, 0, 0, 0.70);\n    animation: isp-modalIn 0.22s cubic-bezier(0.34, 1.20, 0.64, 1);\n  }\n  \n  .isp-modal--out {\n    animation: isp-modalOut 0.18s ease forwards;\n  }\n  \n  @keyframes isp-modalIn {\n    from { opacity: 0; transform: scale(0.92) translateY(16px); }\n    to   { opacity: 1; transform: scale(1)    translateY(0);    }\n  }\n  \n  @keyframes isp-modalOut {\n    from { opacity: 1; transform: scale(1);    }\n    to   { opacity: 0; transform: scale(0.94); }\n  }\n  \n  /* ── Header ────────────────────────────────────────────────────────────── */\n  .isp-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 22px 24px 18px 24px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.07);\n    flex-shrink: 0;\n  }\n  \n  .isp-header-left {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n  }\n  \n  .isp-header-icon {\n    font-size: 1.8rem;\n    flex-shrink: 0;\n  }\n  \n  .isp-title {\n    font-size: 1.1rem;\n    font-weight: 700;\n    color: #ffffff;\n    margin: 0 0 3px 0;\n    padding: 0;\n  }\n  \n  .isp-subtitle {\n    font-size: 12px;\n    color: rgba(255, 255, 255, 0.38);\n    margin: 0;\n    padding: 0;\n  }\n  \n  .isp-close-btn {\n    width: 34px;\n    height: 34px;\n    border-radius: 50%;\n    background: rgba(255, 255, 255, 0.07);\n    border: 1px solid rgba(255, 255, 255, 0.10);\n    color: rgba(255, 255, 255, 0.60);\n    font-size: 20px;\n    line-height: 1;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background 0.15s ease, color 0.15s ease;\n    flex-shrink: 0;\n  }\n  \n  .isp-close-btn:hover {\n    background: rgba(244, 67, 54, 0.18);\n    color: #f44336;\n  }\n  \n  /* ── Live preview strip ────────────────────────────────────────────────── */\n  .isp-preview-strip {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    padding: 14px 24px;\n    background: rgba(255, 255, 255, 0.025);\n    border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n    flex-shrink: 0;\n  }\n  \n  .isp-preview-avatar {\n    position: relative;\n    width: 52px;\n    height: 52px;\n    border-radius: 50%;\n    background: rgba(255, 255, 255, 0.06);\n    border: 2px solid rgba(255, 255, 255, 0.12);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    overflow: hidden;\n  }\n  \n  .isp-preview-emoji { font-size: 1.8rem; }\n  \n  .isp-preview-overlay {\n    position: absolute;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.55);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1.4rem;\n    border-radius: 50%;\n  }\n  \n  .isp-preview-details { flex: 1; min-width: 0; }\n  \n  .isp-preview-row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    margin-bottom: 6px;\n  }\n  \n  .isp-preview-chip {\n    font-size: 11px;\n    font-weight: 600;\n    padding: 4px 10px;\n    border-radius: 20px;\n    border: 1px solid transparent;\n    white-space: nowrap;\n  }\n  \n  .isp-preview-chip--neutral {\n    background: rgba(255, 255, 255, 0.06);\n    border-color: rgba(255, 255, 255, 0.10);\n    color: rgba(255, 255, 255, 0.55);\n  }\n  \n  .isp-preview-chip--virtual {\n    background: rgba(156, 39, 176, 0.14);\n    border-color: rgba(156, 39, 176, 0.30);\n    color: #ce93d8;\n  }\n  \n  .isp-preview-hint {\n    font-size: 11px;\n    color: rgba(255, 255, 255, 0.28);\n    margin: 0;\n    padding: 0;\n  }\n  \n  /* ── Tab bar ───────────────────────────────────────────────────────────── */\n  .isp-tabs {\n    display: flex;\n    flex-direction: row;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.07);\n    flex-shrink: 0;\n    overflow-x: auto;\n    scrollbar-width: none;\n  }\n  \n  .isp-tabs::-webkit-scrollbar { display: none; }\n  \n  .isp-tab {\n    flex: 1;\n    padding: 13px 16px;\n    background: transparent;\n    border: none;\n    border-bottom: 3px solid transparent;\n    color: rgba(255, 255, 255, 0.42);\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n    white-space: nowrap;\n    transition: color 0.18s ease, border-bottom-color 0.18s ease;\n    letter-spacing: 0.01em;\n  }\n  \n  .isp-tab:hover { color: rgba(255, 255, 255, 0.75); }\n  \n  .isp-tab--active {\n    color: #ffffff !important;\n    border-bottom-color: white;\n  }\n  \n  /* ── Scrollable body ───────────────────────────────────────────────────── */\n  .isp-body {\n    flex: 1;\n    overflow-y: auto;\n    scrollbar-width: thin;\n    scrollbar-color: rgba(255, 255, 255, 0.12) transparent;\n  }\n  \n  .isp-body::-webkit-scrollbar       { width: 5px; }\n  .isp-body::-webkit-scrollbar-thumb {\n    background: rgba(255, 255, 255, 0.12);\n    border-radius: 10px;\n  }\n  \n  /* ── Tab content wrapper ───────────────────────────────────────────────── */\n  .isp-tab-content {\n    padding: 22px 24px;\n    animation: isp-tabFade 0.18s ease;\n  }\n  \n  @keyframes isp-tabFade {\n    from { opacity: 0; transform: translateY(5px); }\n    to   { opacity: 1; transform: translateY(0);   }\n  }\n  \n  .isp-section-desc {\n    font-size: 13px;\n    color: rgba(255, 255, 255, 0.45);\n    margin: 0 0 18px 0;\n    line-height: 1.65;\n  }\n  \n  /* ── TAB 1: Visibility option cards ────────────────────────────────────── */\n  .isp-vis-options {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .isp-vis-card {\n    width: 100%;\n    padding: 16px 18px;\n    border-radius: 12px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    background: rgba(255, 255, 255, 0.02);\n    cursor: pointer;\n    text-align: left;\n    transition: border-color 0.18s ease, background 0.18s ease;\n  }\n  \n  .isp-vis-card-top {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n  }\n  \n  .isp-vis-icon {\n    font-size: 1.5rem;\n    flex-shrink: 0;\n    width: 32px;\n    text-align: center;\n  }\n  \n  .isp-vis-info {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n    min-width: 0;\n  }\n  \n  .isp-vis-label {\n    font-size: 14px;\n    font-weight: 700;\n    color: rgba(255, 255, 255, 0.80);\n    transition: color 0.18s ease;\n  }\n  \n  .isp-vis-desc {\n    font-size: 12px;\n    color: rgba(255, 255, 255, 0.38);\n    line-height: 1.55;\n  }\n  \n  .isp-vis-radio {\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    border: 2px solid rgba(255, 255, 255, 0.22);\n    flex-shrink: 0;\n    transition: border-color 0.18s ease, background 0.18s ease;\n  }\n  \n  /* ── TAB 2: Virtual avatar grid ────────────────────────────────────────── */\n  .isp-clear-avatar-btn {\n    background: rgba(244, 67, 54, 0.10);\n    border: 1px solid rgba(244, 67, 54, 0.25);\n    color: #ef9a9a;\n    border-radius: 8px;\n    padding: 9px 16px;\n    font-size: 12.5px;\n    font-weight: 600;\n    cursor: pointer;\n    margin-bottom: 16px;\n    transition: background 0.15s ease;\n  }\n  \n  .isp-clear-avatar-btn:hover {\n    background: rgba(244, 67, 54, 0.18);\n  }\n  \n  .isp-avatar-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 10px;\n  }\n  \n  .isp-avatar-card {\n    position: relative;\n    aspect-ratio: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 5px;\n    background: rgba(255, 255, 255, 0.04);\n    border: 2px solid rgba(255, 255, 255, 0.08);\n    border-radius: 12px;\n    cursor: pointer;\n    transition: border-color 0.18s ease, background 0.18s ease, transform 0.15s ease;\n    padding: 10px 6px;\n    box-sizing: border-box;\n  }\n  \n  .isp-avatar-card:hover {\n    border-color: rgba(76, 175, 80, 0.40);\n    background: rgba(76, 175, 80, 0.06);\n    transform: translateY(-2px);\n  }\n  \n  .isp-avatar-card--selected {\n    border-color: #4caf50 !important;\n    background: rgba(76, 175, 80, 0.13) !important;\n  }\n  \n  .isp-avatar-emoji { font-size: 2rem; }\n  \n  .isp-avatar-label {\n    font-size: 10.5px;\n    color: rgba(255, 255, 255, 0.45);\n    font-weight: 600;\n    text-align: center;\n  }\n  \n  .isp-avatar-check {\n    position: absolute;\n    top: 5px;\n    right: 7px;\n    font-size: 11px;\n    font-weight: 700;\n    color: #81c784;\n  }\n  \n  /* ── TAB 3: Behaviour ──────────────────────────────────────────────────── */\n  .isp-behaviour-card {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    padding: 18px 20px;\n    background: rgba(255, 255, 255, 0.03);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 12px;\n    margin-bottom: 24px;\n  }\n  \n  .isp-behaviour-left {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    flex: 1;\n  }\n  \n  .isp-behaviour-icon {\n    font-size: 1.8rem;\n    flex-shrink: 0;\n    width: 36px;\n    text-align: center;\n    transition: transform 0.3s ease;\n  }\n  \n  .isp-behaviour-info {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n  }\n  \n  .isp-behaviour-title {\n    font-size: 14px;\n    font-weight: 700;\n    color: rgba(255, 255, 255, 0.85);\n  }\n  \n  .isp-behaviour-desc {\n    font-size: 12px;\n    color: rgba(255, 255, 255, 0.40);\n    line-height: 1.55;\n  }\n  \n  /* ── Behaviour demo ────────────────────────────────────────────────────── */\n  .isp-behaviour-demo {\n    background: rgba(255, 255, 255, 0.025);\n    border: 1px dashed rgba(255, 255, 255, 0.10);\n    border-radius: 12px;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 18px;\n  }\n  \n  .isp-behaviour-demo-label {\n    font-size: 10px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n    color: rgba(255, 255, 255, 0.28);\n  }\n  \n  .isp-behaviour-demo-avatar {\n    position: relative;\n    width: 70px;\n    height: 70px;\n    border-radius: 50%;\n    background: rgba(255, 255, 255, 0.06);\n    border: 2px solid rgba(255, 255, 255, 0.10);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: border-color 0.2s ease, transform 0.2s ease;\n  }\n  \n  .isp-behaviour-demo-avatar--clickable {\n    cursor: zoom-in;\n    border-color: rgba(76, 175, 80, 0.35);\n  }\n  \n  .isp-behaviour-demo-avatar--clickable:hover {\n    transform: scale(1.06);\n    border-color: #4caf50;\n    box-shadow: 0 0 20px rgba(76, 175, 80, 0.25);\n  }\n  \n  .isp-behaviour-demo-zoom {\n    position: absolute;\n    bottom: -2px;\n    right: -2px;\n    width: 22px;\n    height: 22px;\n    background: #4caf50;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 11px;\n    border: 2px solid rgb(18, 18, 22);\n  }\n  \n  .isp-behaviour-demo-hint {\n    font-size: 12px;\n    color: rgba(255, 255, 255, 0.35);\n    margin: 0;\n    text-align: center;\n  }\n  \n  /* ── Shared: warning note ──────────────────────────────────────────────── */\n  .isp-warning-note {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    background: rgba(33, 150, 243, 0.08);\n    border: 1px solid rgba(33, 150, 243, 0.20);\n    border-radius: 10px;\n    padding: 13px 16px;\n    margin-top: 14px;\n  }\n  \n  .isp-warning-note span { font-size: 1.1rem; flex-shrink: 0; margin-top: 1px; }\n  \n  .isp-warning-note p {\n    font-size: 12.5px;\n    color: rgba(255, 255, 255, 0.55);\n    margin: 0;\n    padding: 0;\n    line-height: 1.65;\n  }\n  \n  /* ── Footer ────────────────────────────────────────────────────────────── */\n  .isp-footer {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 10px;\n    padding: 16px 24px;\n    border-top: 1px solid rgba(255, 255, 255, 0.07);\n    flex-shrink: 0;\n  }\n  \n  .isp-save-btn,\n  .isp-cancel-btn {\n    padding: 11px 26px;\n    border-radius: 9px;\n    font-size: 13.5px;\n    font-weight: 700;\n    cursor: pointer;\n    transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;\n    border: none;\n  }\n  \n  .isp-save-btn {\n    background: rgba(36,36,45,0.2);\n    color: #fff;\n    border: \"1px solid white\"\n  }\n  \n  .isp-save-btn:hover {\n    transform: translateY(-1px);\n  }\n  \n  .isp-cancel-btn {\n    background: rgba(255, 255, 255, 0.06);\n    color: rgba(255, 255, 255, 0.60);\n    border: 1px solid rgba(255, 255, 255, 0.10);\n  }\n  \n  .isp-cancel-btn:hover {\n    background: rgba(255, 255, 255, 0.10);\n    color: rgba(255, 255, 255, 0.88);\n  }\n  \n  /* ── Clickable trigger (in SelfDetail) ─────────────────────────────────── */\n  .sd-img-vis-trigger {\n    width: 100%;\n    background: rgba(255, 255, 255, 0.025);\n    border: 1px solid rgba(255, 255, 255, 0.09);\n    border-radius: 12px;\n    padding: 14px 16px;\n    cursor: pointer;\n    text-align: left;\n    color: inherit;\n    transition: background 0.18s ease, border-color 0.18s ease, transform 0.15s ease;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  /* .sd-img-vis-trigger:hover {\n    background: rgba(76, 175, 80, 0.07);\n    border-color: rgba(76, 175, 80, 0.30);\n    transform: translateY(-1px);\n  } */\n  \n  .sd-img-vis-trigger-top {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n  }\n  \n  .sd-img-vis-trigger-icon { font-size: 1.3rem; flex-shrink: 0; }\n  \n  .sd-img-vis-trigger-info {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n  }\n  \n  .sd-img-vis-trigger-label {\n    font-size: 13.5px;\n    font-weight: 700;\n    color: rgba(255, 255, 255, 0.85);\n  }\n  \n  .sd-img-vis-trigger-sublabel {\n    font-size: 11.5px;\n    color: rgba(255, 255, 255, 0.38);\n  }\n  \n  .sd-img-vis-trigger-arrow {\n    font-size: 1.4rem;\n    color: rgba(255, 255, 255, 0.30);\n    flex-shrink: 0;\n    transition: transform 0.18s ease, color 0.18s ease;\n  }\n  \n  .sd-img-vis-trigger:hover .sd-img-vis-trigger-arrow {\n    transform: translateX(3px);\n    color: rgba(76, 175, 80, 0.80);\n  }\n  \n  .sd-img-vis-trigger-status {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 7px;\n    padding-top: 2px;\n    border-top: 1px solid rgba(255, 255, 255, 0.06);\n  }\n  \n  .sd-img-vis-chip {\n    font-size: 11px;\n    font-weight: 600;\n    padding: 4px 10px;\n    border-radius: 20px;\n    background: rgba(255, 255, 255, 0.06);\n    color: rgba(255, 255, 255, 0.50);\n    border: 1px solid rgba(255, 255, 255, 0.09);\n  }\n  \n  /* ── Responsive ────────────────────────────────────────────────────────── */\n  @media (max-width: 600px) {\n    .isp-modal          { border-radius: 14px; max-height: 95vh; }\n    .isp-avatar-grid    { grid-template-columns: repeat(3, 1fr); }\n    .isp-tab            { font-size: 12px; padding: 11px 10px; }\n    .isp-footer         { flex-direction: column-reverse; }\n    .isp-save-btn,\n    .isp-cancel-btn     { width: 100%; text-align: center; }\n    .isp-header         { padding: 16px 18px; }\n    .isp-tab-content    { padding: 18px 16px; }\n    .isp-preview-strip  { padding: 12px 16px; }\n  }\n  \n  @media (max-width: 400px) {\n    .isp-avatar-grid { grid-template-columns: repeat(3, 1fr); gap: 8px; }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
